export default function TechStack () {
  return (
    <div className="tech-stack-list">
      HTML CSS Tailwind JS React Redux Next Go Node Python PostgreSQL GraphQL REST GIT Agile
    </div>
  )
};
